export default function IconButton({
    icon: Icon,
    label,
    className = '',
    children = null,
    ...props
}) {
    return (
        <button
            type="button"
            className={`icon-button ${className}`.trim()}
            aria-label={label}
            {...props}
        >
            {Icon ? <Icon size={16} aria-hidden="true" /> : children}
            {label ? <span className="sr-only">{label}</span> : null}
        </button>
    )
}
